import { ActionTree, MutationTree, GetterTree, Module } from 'vuex';
import { RootState } from '../types';

interface LoaderState {
  loading: number;
}

const initialState: LoaderState = {
  loading: 0,
};

const INCREMENT = 'INCREMENT';
const DECREMENT = 'DECREMENT';
const FORCE_STOP = 'FORCE_STOP';

const actions: ActionTree<LoaderState, RootState> = {
  async run({ commit }, fn: Promise<unknown>): Promise<unknown> {
    commit(INCREMENT);
    return fn.finally(() => commit(DECREMENT));
  },

  start({ commit }) {
    commit(INCREMENT);
  },

  stop({ commit }) {
    commit(DECREMENT);
  },

  forceStop({ commit }) {
    commit(FORCE_STOP);
  },
};

const mutations: MutationTree<LoaderState> = {
  [INCREMENT]: (state: LoaderState) => {
    state.loading += 1;
  },
  [DECREMENT]: (state: LoaderState) => {
    state.loading = state.loading > 0 ? state.loading - 1 : 0;
  },
  [FORCE_STOP]: (state: LoaderState) => {
    state.loading = 0;
  },
};

const getters: GetterTree<LoaderState, RootState> = {
  isLoading: (s) => s.loading > 0,
};

const store: Module<LoaderState, RootState> = {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
};

export default store;
